import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';

const groupOrder = {
  AUTO_PUBLISH: 0,
  GLOBAL: 1,
  NOTIFICATION: 2,
};

export const schedulerApi = createApi({
  reducerPath: 'schedulerApi',
  baseQuery,
  tagTypes: ['SchedulerStatus', 'SchedulerHistory'],
  endpoints: (builder) => ({
    getAllSchedules: builder.query({
      query: () => ({
        url: '/scheduler/getAllSchedules',
        method: 'GET',
      }),
      transformResponse: (response) => {
        const groups = response?.result || response || [];

        return [...groups]
          .map((group) => ({
            groupName: group.groupName,
            groupType: group.groupType,
            active: Boolean(group.active),
            schedules: [...(group.schedules || [])]
              .map((schedule) => ({
                name: schedule.name,
                portfolioId: schedule.portfolioId || null,
                portfolioName: schedule.portfolioName || null,
                enabled: Boolean(schedule.enabled),
                scheduleExpression: schedule.scheduleExpression || '-',
                timezone: schedule.timezone || '-',
                description: schedule.description || '',
                scheduleType: schedule.scheduleType || group.groupType,
              }))
              .sort((a, b) => {
                const portfolioCompare = (a.portfolioName || '').localeCompare(
                  b.portfolioName || ''
                );
                if (portfolioCompare !== 0) return portfolioCompare;
                return a.name.localeCompare(b.name);
              }),
          }))
          .sort((a, b) => (groupOrder[a.groupType] ?? 99) - (groupOrder[b.groupType] ?? 99));
      },
      providesTags: ['SchedulerStatus'],
    }),
    getRunHistory: builder.query({
      query: () => ({
        url: '/scheduler/getRunHistory',
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
      transformResponse: (response) => {
        const history = response?.result || response || [];

        return [...history].map((run) => ({
          id: run.id,
          portfolioId: run.portfolioId || null,
          portfolioName: run.portfolioName || null,
          jobType: run.jobType || '-',
          status: run.status || '-',
          errorMessage: run.errorMessage || '',
          metadata:
            typeof run.metadata === 'string'
              ? run.metadata
              : run.metadata
                ? JSON.stringify(run.metadata)
                : '',
          createDate: run.createDate || null,
        }));
      },
      providesTags: ['SchedulerHistory'],
    }),
  }),
});

export const { useGetAllSchedulesQuery, useGetRunHistoryQuery } = schedulerApi;
